import styled from 'styled-components'

import {
  sizing,
  focusedStyles,
  placeholderStyles,
  borderOutlineStyles,
  getMenuDirectionStyles,
  getToggleDirectionStyles
} from './styles'

import { lists, buttonReset, base } from '../mixins'
import { PB40T, WHITE, SLB10S } from '../colors'

const SelectWrap = styled.div`
  width: ${({ width }) => width};
  display: flex;
  flex-direction: ${({ menuDirection }) =>
    menuDirection === 'up' ? 'column-reverse' : 'column'};
`
const SelectToggleButton = styled.button`
  ${buttonReset};
  ${base};
  ${borderOutlineStyles}
  border-radius: 5px;
  line-height: 1;
  font-size: ${({ size }) => sizing[size].fontSize};
  color: ${({ color }) => color};
  padding: ${({ size }) => sizing[size].padding};
  text-align: left;
  background-color: white;
  background-clip: padding-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  &:focus {
    ${focusedStyles};
  }

  &[aria-expanded='true'] {
    ${focusedStyles};
    ${getToggleDirectionStyles}
    background-color: rgba(0, 0, 0, 0.08);
  }

  &:disabled {
    color: ${PB40T};
    cursor: not-allowed;
    background-color: rgba(0, 0, 0, 0.08);
  }
`
const SelectMenu = styled.ul`
  ${lists};
  position: absolute;
  left: 0;
  max-height: 205px;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  z-index: 1000;
  outline: 0;
  background-color: white;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  ${getMenuDirectionStyles}
`
const SelectMenuWrap = styled.div`
  position: relative;
  top: ${({ menuDirection }) => (menuDirection === 'up' ? '1px' : '-1px')};

  ${SelectToggleButton}[aria-expanded="false"] + & {
    display: none;
  }

  ${SelectToggleButton}[aria-expanded="true"] + & {
    span {
      color: ${WHITE};
    }
    ${SelectMenu} {
      ${focusedStyles};
    }
  }
`
const SelectItem = styled.li`
  ${base};
  color: ${({ color }) => color};
  font-size: ${({ size }) => sizing[size].fontSize};
  padding: ${({ size }) => sizing[size].padding};
  &.highlighted {
    background-color: ${SLB10S};
    color: white;
  }
`
const SelectPlaceholder = styled.span`
  ${placeholderStyles};
  line-height: initial;
`
const SelectedItem = styled.span`
  line-height: initial;
`

export {
  SelectWrap,
  SelectToggleButton,
  SelectMenuWrap,
  SelectMenu,
  SelectItem,
  SelectPlaceholder,
  SelectedItem
}
